import { Box, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { WorkflowStage } from '../../interfaces/ui';
import './styles/executionStepper.css';

export default function ExecutionStepper({
  workflowStages,
}: {
  workflowStages: WorkflowStage[];
}) {
  return (
    <Box className="ec-stepper-section">
      <Box className="ec-stepper-container">
        {workflowStages.map((stage, index) => (
          <Box key={stage.id} className="ec-stepper-item">
            <Box
              className={`ec-stepper-node ${
                stage.status === 'completed'
                  ? 'ec-stepper-node-completed'
                  : stage.status === 'active'
                  ? 'ec-stepper-node-active'
                  : 'ec-stepper-node-pending'
              }`}
            >
              {stage.status === 'completed' && <CheckIcon />}
              {stage.status === 'active' && (
                <Box className="ec-stepper-spinner" />
              )}
              {stage.status === 'pending' && (
                <Box component="span" className="ec-stepper-pending-dot" />
              )}
            </Box>
            <Typography
              component="span"
              className={`ec-stepper-label${
                stage.status === 'pending' ? ' ec-stepper-label-pending' : ''
              }`}
            >
              {stage.label}
            </Typography>
            {index < workflowStages.length - 1 && (
              <Box
                className={`ec-stepper-connector${
                  stage.status === 'completed'
                    ? ' ec-stepper-connector-completed'
                    : ''
                }`}
              />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
